import { Home, LayoutDashboard, ShoppingCart, User } from "lucide-react";
import useFixedBarHeight, { FOOTER_NAV_HEIGHT_VAR } from "@/hooks/useFixedBarHeight";
import { FOOTER_NAV_BAR_CLASS, footer_nav_item_class } from "../footerNavStyles";

const navigationItems = [
    {
        id: 1,
        title: "خانه",
        icon: "home",
        active: true,
    },
    {
        id: 2,
        title: "دسته بندی",
        icon: "category",
    },
    {
        id: 3,
        title: "سبد خرید",
        icon: "cart",
    },
    {
        id: 4,
        title: "مجله ژومنت",
        icon: "blog",
    },
    {
        id: 5,
        title: "پروفایل",
        icon: "profile",
    },
];

const FooterIcons = {

    home:
        <Home size={24} />,

    category:
        <LayoutDashboard size={24} />,

    cart:
        <ShoppingCart
            size={24}
        />,

    blog:
        (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="#737373"
                    strokeWidth="2"
                />

                <path
                    d="M12.9004 9.10001V16C12.9004 16 13.0004 18 11.1004 18.1H9.40039V17.1H10.7004C10.7004 17.1 11.5004 17.1 11.5004 16.1V9.10001"
                    fill="#737373"
                />

                <path
                    d="M11.5996 7.39999V5.89999H12.8996V8.29999H9.09961V7.39999H11.5996Z"
                    fill="#737373"
                />

            </svg>
        ),

    profile:
        <User
            size={24}
        />
};


export default function FooterNavigationServer() {

    const barRef = useFixedBarHeight(FOOTER_NAV_HEIGHT_VAR);

    return (

        <footer ref={barRef} className={FOOTER_NAV_BAR_CLASS}
        >

            {navigationItems.map((item) => (

                <div key={item.id}
                    className={footer_nav_item_class(item.active)}
                >

                    {FooterIcons[item.icon]}


                    {item.badge && (
                        <div className="flex items-center justify-center absolute -top-2 right-1.5 w-5 h-5 bg-jmt-primary-700 border border-jmt-neutral-100 rounded-md "
                        >
                            <span className="text-jmt-white text-[10px]">
                                {item.badge}
                            </span>

                        </div>
                    )}

                    <span>
                        {item.title}
                    </span>

                </div>

            ))
            }

        </footer>

    );
}